import React from 'react';
import styled from 'styled-components';
import { Type } from '@spotify-internal/encore-creator-web';
import {
  spacer4,
  spacer24,
  spacer32,
  spacer40,
  screenXsMax,
  screenSmMin,
} from '@spotify-internal/encore-foundation';
import { formatter } from '../../../shared/lib/numberHelpers';
import { BarAnimation } from '../../../shared/components/BarAnimation';
import { ArtistLiveListeners } from '../../ArtistLiveListeners';
import { useCurrentArtist } from '../../../features/artists';

const numberFormatter = formatter({ useGrouping: true });

const HeaderTitle = styled(Type.h1).attrs({
  variant: Type.heading1,
  condensed: true,
})`
  grid-area: header;
  margin-top: ${spacer32};
`;

const HeaderText = styled(Type.h1).attrs({
  variant: Type.heading4,
  weight: Type.bold,
  condensed: true,
})`
  display: inline-block;
`;

const NumberListeners = styled(HeaderText)`
  margin-left: 6px;
  font-feature-settings: 'tnum';
`;

const ListeningNow = styled(HeaderText)`
  margin-left: ${spacer4};
`;

const LiveListeners = styled.div`
  grid-area: listeners;

  @media (max-width: ${screenXsMax}) {
    margin-bottom: ${spacer40};
  }

  @media (min-width: ${screenSmMin}) {
    margin-bottom: ${spacer24};
  }
`;

const HeaderSection = React.memo(() => {
  const artist = useCurrentArtist();

  return (
    <ArtistLiveListeners
      key={artist.id}
      render={listeners => (
        <React.Fragment>
          <HeaderTitle>Home</HeaderTitle>
          <LiveListeners>
            <BarAnimation />
            <NumberListeners data-testid="live-listeners">
              {listeners >= 0 ? numberFormatter.format(listeners) : 0}
            </NumberListeners>
            <ListeningNow>people listening now</ListeningNow>
          </LiveListeners>
        </React.Fragment>
      )}
    />
  );
});

/* eslint-disable-next-line import/no-default-export */
export default HeaderSection;
